// authReducer.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type Institution = {
  name: string;
  email: string;
  type: string;
  address: string;
  year: string;
  contactPersonName: string;
  contactPersonDesignation: string;
  contactEmail: string;
  contactPhoneNumber: string;
};

type Recruiter = {
  name: string;
  email: string;
  type: string;
  address: string;
  numberOfEmployees: string;
  recruiterName: string;
  recruiterDesignation: string;
  contactEmail: string;
  contactPhoneNumber: string;
};

type AuthState = {
  register: {
    institution: Institution;
    recruiter: Recruiter;
  };
};

// Initial state
const initialState: AuthState = {
  register: {
    institution: {
      name: '',
      email: '',
      type: '',
      address: '',
      year: '',
      contactPersonName: '',
      contactPersonDesignation: '',
      contactEmail: '',
      contactPhoneNumber: ''
    },
    recruiter: {
      name: '',
      email: '',
      type: '',
      address: '',
      numberOfEmployees: '',
      recruiterName: '',
      recruiterDesignation: '',
      contactEmail: '',
      contactPhoneNumber: ''
    }
  }
};

// Create slice or reducer
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Add your reducers here
    updateInstitution(state, action: PayloadAction<Partial<Institution>>) {
      state.register.institution = {
        ...state.register.institution,
        ...action.payload
      };
    },
    resetInstitution(state) {
      state.register.institution = initialState.register.institution;
    },
    updateRecruiter(state, action: PayloadAction<Partial<Recruiter>>) {
      state.register.recruiter = {
        ...state.register.recruiter,
        ...action.payload
      };
    },
    resetRecruiter(state) {
      state.register.recruiter = initialState.register.recruiter;
    }
  }
});

export const {
  updateInstitution,
  resetInstitution,
  updateRecruiter,
  resetRecruiter
} = authSlice.actions;
export default authSlice.reducer;
